import { FilterType, type Filter } from "@/v2/framework/filter/types";
import type { BackofficeContext } from "@/v2/framework/context/types";

import { sportGamesStatusOptions, sportStatusOptions } from "../shared";

export function createFilters(options: { ctx: BackofficeContext }): Filter[] {
  const { ctx } = options;

  return [
    {
      key: "status",
      label: "common.labels.status",
      placeholder: "common.labels.status",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: sportStatusOptions,
      multiple: true,
    },
    {
      key: "liveGameStatus",
      label: "common.labels.live_status",
      placeholder: "common.labels.live_status",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: sportGamesStatusOptions,
      multiple: true,
    },
    {
      key: "prematchGameStatus",
      label: "common.labels.prematch_status",
      placeholder: "common.labels.prematch_status",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: sportGamesStatusOptions,
      multiple: true,
    },
    {
      key: "language",
      label: "common.labels.language",
      placeholder: "common.labels.language",
      filterType: FilterType.Select,
      syncRouteQuery: true,
      options: async () =>
        ctx.read.languages().map((language) => ({
          value: language.code,
          title: `languages.${language.code}`,
        })),
      multiple: false,
      searchable: true,
    },
  ];
}
